import type { OrderInfo } from '../../gql';

import {
    randNumber,
    randSentence,
    randBoolean,
    randCountryCode,
    randPastDate,
    randFutureDate,
} from '@ngneat/falso';

import {
    mockOrderCompany,
    mockOrderCollection,
    mockOrderIssuer,
    mockOrderLabel,
    mockOrderStyle,
    mockOrderKeyOrder,
    mockOrderUser,
    mockOrderComposition,
    mockOrderState,
    mockOrderPrice,
    mockOrderHeaderStandardText,
} from './mockOrderFragments';

/** Will return a mocked OrderInfo object, useful for tests etc. */
const mockOrderInfo = (overwrite?: Partial<OrderInfo>): OrderInfo => {
    const baseOrderInfo: OrderInfo = {
        orderNumber: randNumber({ min: 1000000, max: 9999999 }),
        state: mockOrderState(),
        changedBy: randBoolean() ? mockOrderUser() : undefined,
        createdBy: mockOrderUser(),
        createdDate: randPastDate(),
        changedDate: randBoolean() ? randPastDate() : undefined,
        earliestCargoClosingDate: randFutureDate(),
        style: mockOrderStyle(),
        label: randBoolean() ? mockOrderLabel() : undefined,
        price: mockOrderPrice(),
        collection: mockOrderCollection(),
        isPolybagged: randBoolean() ? randBoolean() : null,
        isPressed: randBoolean(),
        isHanging: randBoolean(),
        isDangerousGoods: randBoolean(),
        isReadyForLabelProduction: randBoolean(),
        isPackingNoteTransmitted: randBoolean(),
        issuer: mockOrderIssuer(),
        supplier: mockOrderCompany(),
        factory: mockOrderCompany(),
        businessTradingPartner: randBoolean() ? mockOrderCompany() : undefined,
        countryOfOriginCode: Array.isArray(randCountryCode())
            ? randCountryCode()[0]
            : randCountryCode(),
        countryOfOriginName: 'Sample Origin Country Name',
        countryOfDutyCode: Array.isArray(randCountryCode())
            ? randCountryCode()[0]
            : randCountryCode(),
        countryOfDutyName: 'Sample Duty Country Name',
        countryOfDestinationCode: Array.isArray(randCountryCode())
            ? randCountryCode()[0]
            : randCountryCode(),
        countryOfDestinationName: 'Sample Destination Country Name',
        paymentTerm: {
            paymentTermCode: 'PT30',
            paymentTermName: '30 days net',
        },
        keyOrder: randBoolean() ? mockOrderKeyOrder() : undefined,
        releasedToSupplierDate: randFutureDate(),
        composition: randBoolean() ? mockOrderComposition() : undefined,
        sellInDate: randBoolean() ? randFutureDate() : undefined,
        cancelDate: randBoolean() ? randFutureDate() : undefined,
        packing: randBoolean()
            ? mockOrderHeaderStandardText({
                  standardText: 'Packing Instructions',
              })
            : undefined,
        comment: randBoolean()
            ? mockOrderHeaderStandardText({ standardText: 'Order Comment' })
            : undefined,
        note: randBoolean() ? randSentence({ length: 3 }).join(' ') : undefined,
        buyer: mockOrderUser(),
    };

    return { ...baseOrderInfo, ...overwrite };
};

export { mockOrderInfo };
